import {Typography} from '~library/atoms/Typography';

import './EditorHeader.sass';

export const EditorHeader = ({title, extra, extra2, dark = false}) => (
  <div className="editor-header">
    <Typography variant="label2" color={dark ? 'charcoal' : 'pebble'}>
      {title}
    </Typography>
    {extra2 ? (
      <div className="header__extras">
        <div className="header__extra">{extra2}</div>
        <div className="header__extra">{extra}</div>
      </div>
    ) : (
      <div className="header__extra">{extra}</div>
    )}
  </div>
);
